<template>
  <div class="page-content homeworkPage">
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">我的订单</span>
    </p>
    <div class="content">
      <div class="order-tabs">
        <span :class="{ on: form.payStatus === '' }" @click="changeStatus('')">全部</span>
        <span :class="{ on: form.payStatus === '0' }" @click="changeStatus('0')">待支付</span>
        <span :class="{ on: form.payStatus === '1' }" @click="changeStatus('1')">已支付</span>
      </div>
      <div v-if="list.length == 0" style="text-align: center;">暂无订单</div>
      <div class="li" v-for="(item, index) in list" :key="item.orderId || item.orderNo || index">
        <div v-if="item.orderNo" class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">订单号：</p>
            <p class="color3">{{ item.orderNo }}</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">类型：</p>
            <p class="color3">{{ typeText(item.type) }}</p>
          </div>
        </div>
        <div v-if="item.product" class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">缴费内容：</p>
            <p class="color3">{{ item.product }}</p>
          </div>
        </div>
        <div v-if="item.describe" class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">描述：</p>
            <p class="color3">{{ item.describe }}</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">金额：</p>
            <p class="color3 money">{{ formatMoney(item.amount) }}</p>
          </div>
        </div>
        <div v-if="item.createTime" class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">创建时间：</p>
            <p class="color3">{{ item.createTime }}</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">状态：</p>
            <p class="color3">{{ isPaidOrder(item) ? '已开通' : '未缴' }}</p>
          </div>
        </div>
        <div class="btns">
          <el-button size="mini" @click="openDetail(item)">详情</el-button>
          <el-button v-if="showPay(item)" size="mini" class="my-btn" type="primary" @click="handlePay(item)">去支付</el-button>
        </div>
      </div>
    </div>
    <div class="pagination" v-if="total > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="form.size"
        :total="total"
        :current-page="form.page"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <PayDialog ref="payDialog" @refresh="getData" />
    <el-dialog title="订单详情" :visible.sync="detailVisible" width="720px">
      <table class="table table-bordered" v-if="detail">
        <tbody>
          <tr>
            <th>订单编号</th>
            <td>{{ detail.orderNo }}</td>
            <th>类型</th>
            <td>{{ typeText(detail.type) }}</td>
          </tr>
          <tr>
            <th>金额</th>
            <td class="money">{{ formatMoney(detail.amount) }}</td>
            <th>状态</th>
            <td>{{ isPaidOrder(detail) ? '已开通' : '未缴' }}</td>
          </tr>
          <tr v-if="detail.product">
            <th>缴费内容</th>
            <td colspan="3">{{ detail.product }}</td>
          </tr>
          <tr v-if="detail.describe">
            <th>描述</th>
            <td colspan="3">{{ detail.describe }}</td>
          </tr>
          <tr v-if="detail.createTime">
            <th>创建时间</th>
            <td colspan="3">{{ detail.createTime }}</td>
          </tr>
        </tbody>
      </table>
      <el-table v-if="detailCourses.length" :data="detailCourses" border style="width: 100%; margin-top: 12px"
        :header-cell-style="{ background: '#E9EFF9', color: '#1a1a1a', fontWeight: '500' }">
        <el-table-column prop="courseCode" label="课程代码" align="center"></el-table-column>
        <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
        <el-table-column label="金额" align="center" width="120">
          <template slot-scope="scope">{{ formatMoney(scope.row.amount) }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import PayDialog from './registrationPayDialog.vue'
import { canPayOrder, isOrderPaid, orderTypeText } from '@/utils/studyFee'

export default {
  components: {
    PayDialog,
  },
  data () {
    return {
      list: [],
      form: {
        size: 10,
        page: 1,
        payStatus: '',
      },
      total: 0,
      detailVisible: false,
      detail: null,
    }
  },
  computed: {
    detailCourses () {
      return (this.detail && Array.isArray(this.detail.courses)) ? this.detail.courses : []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    typeText (type) {
      return orderTypeText(type)
    },
    isPaidOrder (order) {
      return isOrderPaid(order)
    },
    showPay (order) {
      return canPayOrder(order)
    },
    formatMoney (value) {
      if (value === null || value === undefined || value === '') return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return value
      return num.toFixed(2)
    },
    getData () {
      const params = {
        page: this.form.page,
        size: this.form.size,
      }
      if (this.form.payStatus !== '') params.payStatus = this.form.payStatus
      this.$http.get('/student/pc/chooseCourse/orders', params).then((res) => {
        const records = Array.isArray(res) ? res : ((res && res.records) || [])
        this.list = records
        this.total = Array.isArray(res)
          ? res.length
          : (res && res.total !== undefined && res.total !== null ? res.total : records.length)
      }).catch(() => {
        this.list = []
        this.total = 0
      })
    },
    changeStatus (payStatus) {
      if (this.form.payStatus === payStatus) return
      this.form.payStatus = payStatus
      this.form.page = 1
      this.getData()
    },
    changePage (page) {
      this.form.page = page
      this.getData()
    },
    handlePay (order) {
      if (!canPayOrder(order)) return
      this.$refs.payDialog.open(order)
    },
    openDetail (item) {
      if (!item || !item.orderId) return
      this.$http.get('/student/pc/chooseCourse/orders/' + item.orderId).then((res) => {
        this.detail = res || item
        this.detailVisible = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.order-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 8px;
  border-bottom: 1px solid #f2f2f2;

  span {
    padding: 8px 0 10px;
    cursor: pointer;
    color: #666;
  }

  .on {
    color: #0065BA;
    font-weight: 600;
    border-bottom: 2px solid #0065BA;
  }
}

.btns {
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  margin-top: 8px;

  .my-btn {
    margin-left: 10px;
  }
}

.money {
  color: red;
  font-weight: bold;
}

.homeworkPage {
  .content {
    box-sizing: border-box;
    padding: 0 50px;
    min-height: 450px;

    .li {
      width: 100%;
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      padding: 20px 0;

      .descBox {
        font-size: 14px;
        margin-bottom: 10px;

        .descLi {
          margin-right: 50px;
        }
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    align-content: center;
  }
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #ddd;
    text-align: left;
  }

  th {
    width: 90px;
    background: #f5f5f5;
    font-weight: 600;
  }
}
</style>
